import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentConsultDialog } from '../page/consult-content';

@Component({
    selector: 'app-consult-now-modal',
    templateUrl: './consult-now-modal.component.html',
    styleUrls: ['../consult-now.component.css'],
    standalone: false
})
export class ConsultNowModalComponent implements OnInit{
  @Input() id?: string;
  ButtonName = " Contact Us "
  constructor(public dialog: MatDialog) {
  }
  ngOnInit(): void {
    if (this.id == "welcomedialog"){
      this.ButtonName = " Consult Now ";
    }
    if (this.id == "requestcallbackdialog"){
      this.ButtonName = " Request a call back ";
    }
    if (this.id == "applyjob"){
      this.ButtonName = " Apply job ";
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentConsultDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
    localStorage.setItem('Dialogopen',this.id as string)
  }
}
